import { Reveal, MaskedLines } from "./Reveal";

const chain = ["CATALOGO", "STOCK", "ORDINE", "BRANDING", "PACKAGING", "FULFILLMENT", "CLIENTE"];

export const Positioning = () => {
  return (
    <section className="bg-ink text-ivory py-20 sm:py-32" data-testid="positioning">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-goldtan mb-8">CAPITOLO 06 — POSIZIONAMENTO</p>
        </Reveal>
        <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-[5.5rem] leading-[1.0] tracking-tight max-w-5xl">
          <MaskedLines
            lines={["Non vogliamo essere", "il tuo fornitore.", "Vogliamo essere l'infrastruttura", "del tuo brand."]}
          />
        </h2>

        <Reveal delay={0.1}>
          <p className="mt-12 font-sans-ui text-base sm:text-lg text-ivory/70 leading-relaxed max-w-2xl">
            Un normale fornitore ti vende la merce. My Brand Online è progettato per lavorare dietro l'intero
            ciclo operativo del tuo ecommerce.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p data-testid="positioning-extra" className="mt-5 font-sans-ui text-base sm:text-lg text-ivory/70 leading-relaxed max-w-2xl">
            Dal prodotto al packaging, ogni dettaglio lavora per rendere il tuo brand riconoscibile e coerente agli occhi del cliente.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-16 sm:mt-24 flex flex-wrap items-center gap-x-4 gap-y-5">
            {chain.map((c, i) => (
              <div key={c} className="flex items-center gap-4 sm:gap-6">
                <span className="font-display text-xl sm:text-3xl lg:text-4xl text-ivory/90">{c}</span>
                {i < chain.length - 1 && <span className="text-goldtan text-lg sm:text-2xl">→</span>}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <div className="mt-20 sm:mt-28 grid sm:grid-cols-2 gap-8 border-t hairline-light pt-12">
            <p className="font-display italic text-3xl sm:text-4xl text-ivory">Tu costruisci ciò che il cliente vede.</p>
            <p className="font-display italic text-3xl sm:text-4xl text-goldtan">Noi gestiamo ciò che c'è dietro.</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
